'use strict';
var processInclude = require('base/util');
$(document).ready(function () {
    processInclude(require('./components/top_site/styling'));
});
